// const URL = "http://18.140.193.173:3000/api";
const URL = "https://be.weiots.io/api";
// const URL_ANTARES = "http://18.140.193.173:3006/api";
const URL_ANTARES = "https://be.weiots.io/antares";

const URL_IKI = "https://be.weiots.io/iki";
// const URL = "http://localhost:3002/api";
const LOCAL_URL = "http://localhost:3000";

export { URL, LOCAL_URL, URL_ANTARES, URL_IKI };
